import Vue from 'vue'
//lib para conversão de datas
window.moment = require('moment');
window.moment.locale('pt-br');

var VueTruncate = require('vue-truncate-filter')
Vue.use(VueTruncate)

Vue.filter('inputClassErro', function(erro){
	return  erro ? 'form-group has-error has-feedback' :  'form-group has-feedback'
})

Vue.filter('data', function(date){
  if (date)
    return moment(date).format('DD-MM-YYYY')
  else
    return ''
})

Vue.filter('dataHora', function(date){
    if (date)
      return moment(date).format('DD-MM-YYYY, H:mm:ss')
    else
      return ''
})

Vue.filter('dataHoraCurta', function(date){
    if (date)
      return moment(date).format('DD-MM-YYYY, H:mm')
    else
      return ''
})

Vue.filter('hora', function(date){
    if (date)
      return moment(date).format('H:mm')
    else
      return ''
})

// setar prefixo em url [parametro 'prefixo da url']
Vue.filter('urlPrefix', function(url, prefix){
      return prefix + url
})

Vue.filter('removeUnderlineText', function (value) {
  return  value.replace(/_/g, " ")
})

Vue.filter('classIcoP', function(value){

    let ico = ''
    switch (value) {
      case 'pdf':
        ico = 'fa-file-pdf-o text-danger'
        break;
      case 'doc':
      case 'docx':
        ico = 'fa-file-word-o text-primary'
        break;
      case 'txt':
        ico = 'fa-file-text-o img-ico-anexo'
        break;
      case 'jpg':
      case 'png':
      case 'jpeg':
        ico = 'fa-file-image-o'
        break;
      default:

    }
    return 'fa ' + ico
})
